import React from "react";
import { Image } from "react-native";

export const AppStore = ({
  deepLink,
}: {
  deepLink: string;
}) => {
  return (
    <a
      href={
        deepLink ||
        "https://apps.apple.com/gb/app/get-ball/id1570036235"
      }
      style={{ textDecoration: "none", color: "unset" }}
    >
      <Image
        resizeMode={"contain"}
        source={require("../common/images/downloadIosBlack.png")}
        style={{ width: 140, height: 60 }}
      />
    </a>
  );
};
